
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MeasurementSpecification, MeasurementValueType } from '../../backend/backendapi';
import TestEquipmentMeasurementSpecificationEditor from './TestEquipmentMeasurementSpecificationEditor';

@Component({
  components: {
    TestEquipmentMeasurementSpecificationEditor,
  },
})
export default class TestEquipmentMeasurementSpecificationEditModal extends Vue {
  specification: MeasurementSpecification | null = null;

  get canSave(): boolean {
    return !!this.specification?.name
        && (
            (this.specification.type === MeasurementValueType.Float && this.specification?.lowerBound !== undefined)
            || this.specification.type === MeasurementValueType.String
        )
        && this.specification?.nominalValue !== undefined
        && (
            (this.specification.type === MeasurementValueType.Float && this.specification?.upperBound !== undefined)
            || this.specification.type === MeasurementValueType.String
        );
  }

  public open(specification: MeasurementSpecification): void {
    this.specification = MeasurementSpecification.fromJS(specification); //edit copy
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
